export default __webpack_public_path__ + "static/media/Liszt-V.8a96f03d.mp3";